var map = {
	"./amazon.png": 1668,
	"./appel.png": 3644,
	"./googlepay.png": 6475,
	"./master.png": 2898,
	"./path36.png": 6482,
	"./paytm.png": 4097,
	"./upi.png": 6354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2879;